import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons'

import './App.sass';

import About from './components/About.jsx';
import Contact from './components/Contact.jsx';
import Home from './components/Home.jsx';
import Shows from './components/Shows.jsx';
import Music from './components/Music.jsx';

library.add(fas);

function App() {
  const navOptions = ['Home', 'About', 'Music', 'Shows', 'Contact'];
  const { nav } = useParams();

  const bannerLogo = require('./assets/banner_logo.png');
  const baselogoSize = {width: 668.352, height: 160.952}
  const logoAspect = baselogoSize.height / baselogoSize.width;
  const screenRatio = baselogoSize.width / 1200;

  const getScreenWidth = () => {
    return window.innerWidth < 1200 ? window.innerWidth : 1200;
  };

  const getLogoSize = () => {
    return {
      width: getScreenWidth() * screenRatio,
      height: getScreenWidth() * screenRatio * logoAspect
    }
  };

  const bigStyle = {
    ...getLogoSize(),
    marginRight: (getLogoSize().width * -1) + 'px',
    marginBottom: (getLogoSize().height * -1) + 'px',
    translate: (((getScreenWidth() / 2) - (getLogoSize().width / 2)) - 20) + 'px ' + (getScreenWidth() > 800 ? '100px' : '-10px'),
    flex: '0 0 0',
    overflow: 'visible'
  };

  const smallStyle = {
    width: (baselogoSize.width / 4),
    height: (baselogoSize.height / 4),
    translate: '0 ' + (window.innerWidth > 1200 ? '6px' : '0')
  };

  const [show, setShow] = useState(false);
  const [activeContent, setActiveContent] = useState(nav);
  const [logoStyle, setLogoStyle] = useState(nav === 'Home' || !nav ? bigStyle : smallStyle);
  const [navState, setNavState] = useState(nav === 'Home' || !nav ? 'big' : 'small');

  const ensmallen = () => {
    setLogoStyle(smallStyle);
    setNavState('small');
  };

  const embiggen = () => {
    setLogoStyle(bigStyle);
    setNavState('big');
  };

  useEffect(() => {
      const onScroll = () => {
        if (window.scrollY > 5)
          ensmallen();
        else if (activeContent === 'Home' || !activeContent)
          embiggen();
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      return () => window.removeEventListener('scroll', onScroll);
  }, [embiggen, ensmallen, activeContent]);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const renderContent = () => {
    switch (activeContent) {
      case 'Home':
        return <Home navOptionClicked={navOptionClicked}/>
      case 'About':
        return <About />
      case 'Shows':
        return <Shows />
      case 'Music':
        return <Music />
      case 'Contact':
        return <Contact />
      default:
        return <Home navOptionClicked={navOptionClicked}/>
    }
  };

  const navOptionClicked = (option) => {
    setActiveContent(option);
    window.scrollTo(0, 0);
    if (option !== 'Home')
      ensmallen();
    else
      embiggen();
    handleClose();
  };

  const renderAnimatedLogo = () => {
    return <img className="BealtaineLogo" src={bannerLogo}
      alt="Bealtaine" style={logoStyle} />;
  };

  const renderNav = (renderLogo) => {
    return (
      <div className="NavContainer">
        {renderLogo ? renderAnimatedLogo() : ''}
        <nav style={(navState === 'small' && window.innerWidth > 800) ? {width: '75%'} : {}}>
          {navOptions.map(option => (
            <Link  key={option} className={'Celtic ' + (activeContent === option ? 'Active' : '')}
              to={'/' + option} onClick={() => navOptionClicked(option)}>{option}</Link>
          ))}
          <a className="Celtic" href="https://bealtaineceol.bandcamp.com/"
            target="_blank" rel="noreferrer">Merch</a>
        </nav>
      </div>
    );
  };

  const renderBigNav = () => {
    return (
      <div className="BigNav">
        {renderNav(true)}
      </div>
    );
  };

  const renderSmallNav = () => {
    return (
      <div className="SmallNav" style={navState === "big" && (nav === "Home" || !nav) ?
        {backgroundImage: "unset", backgroundColor: "unset", boxShadow: "unset"} : {}}>
        {renderAnimatedLogo()}
        <h1 className="NavMenu" onClick={handleShow}>
          <FontAwesomeIcon icon="fa-solid fa-bars" />
        </h1>
        <Modal show={show}
          onHide={handleClose}
          keyboard={true}
          fullscreen={true}
          contentClassName="ModalContent">
          <Modal.Header>
            <h1 onClick={handleClose}>
              <FontAwesomeIcon icon="fa-solid fa-xmark" />
            </h1>
          </Modal.Header>
          <Modal.Body>
            {renderNav(false)}
          </Modal.Body>
        </Modal>
      </div>
    )
  };

  const renderFooter = () => {
    return (
      <div className="Footer">
        <span>© Bealtaine {new Date().getFullYear()}</span>
      </div>
    )
  };

  return (
    <div className="App">
      {window.innerWidth > 800 ? renderBigNav() : renderSmallNav()}
      {renderContent()}
      {renderFooter()}
    </div>
  );
}

export default App;
